class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    
    const stepsConfigAttr = this.getAttribute('steps-config');
    try {
      this.stepsConfig = stepsConfigAttr ? JSON.parse(stepsConfigAttr) : [];
    } catch (e) {
      console.error('Invalid steps-config JSON:', e);
      this.stepsConfig = [];
    }
    
    this.itemsByStep = {};
    this.stepsConfig.forEach(step => {
      this.itemsByStep[step.stepId] = [];
    });
    
    this.currentStep = 1;
    this.settings = {
      discountPercentage: parseInt(this.getAttribute('discount-percentage')) || 30,
      discountCode: this.getAttribute('discount-code') || 'BUNDLE30'
    };

    this.sidebarCart = null;
    this.progressBar = null;
    this.ctaButton = null;
    this.totalOriginal = null;
    this.totalDiscounted = null;
    this.stepElements = {};
    this.cartStepElements = {};

    this._variantInventoryCache = new Map();
    this._cartCache = { ts: 0, cart: null };
    this._quickAddUpdateToken = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheDOMElements();
    this.syncAllCardPrices();
    this.loadFromLocalStorage();
    this.initTabs();
    this.initColorFilters();
    this.initCustomDropdowns();
    this.refreshAllDropdownAvailability();
    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
    this.initQuantityControls();
    this.initMobileQtyCustomDropdowns();
    this.initAddToBundleButtons();
    this.initQuickAdd13Buttons();
    this.initSidebarCart();
    this.initMobileSidebar();
    this.initCtaCloseSidebar();
  }

  cacheDOMElements() {
    this.sidebarCart = this.querySelector('.bundle-sidebar-cart');
    this.progressBar = this.querySelector('.bundle-progress-fill');
    this.ctaButton = this.querySelector('[data-cart-cta]');
    this.totalOriginal = this.querySelector('[data-total-original]');
    this.totalDiscounted = this.querySelector('[data-total-discounted]');
    this.cartSubtitle = this.querySelector('.bundle-cart-subtitle');
    this.goalText = this.querySelector('[data-goal-text]');
    
    this.stepsConfig.forEach((step, index) => {
      const stepNumber = index + 1;
      this.stepElements[step.stepId] = this.querySelector(`[data-step="${stepNumber}"]`);
      this.cartStepElements[step.stepId] = this.querySelector(`[data-cart-step="${stepNumber}"]`);
    });
  }
  initTabs() {
    const tabs = this.querySelectorAll('.bundle-tab');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabId = tab.getAttribute('data-tab');
        const tabStep = parseInt(tab.getAttribute('data-step'));

        const stepTabs = this.querySelectorAll(`.bundle-tab[data-step="${tabStep}"]`);
        stepTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        const stepElement = this.querySelector(`.bundle-step[data-step="${tabStep}"]`);
        if (!stepElement) return;

        const stepTabContents = stepElement.querySelectorAll('.bundle-product-grid');
        stepTabContents.forEach(content => content.classList.remove('active'));

        const activeContent = stepElement.querySelector(`.bundle-product-grid[data-tab-content="${tabId}"]`);
        if (activeContent) {
          activeContent.classList.add('active');
        }
        
        const colorFilters = this.querySelectorAll('.bundle-color-filter-wrapper[data-step="' + tabStep + '"]');
        colorFilters.forEach(filter => {
          const filterTabContent = filter.getAttribute('data-tab-content');
          if (filterTabContent === tabId) {
            filter.style.display = 'block';
            
          } else if (filterTabContent) {
            filter.style.display = 'none';
          }
        });
        
        this.applyColorFilters();
        this.updateClearButtonVisibility();
      });
    });
  }

  goToStep(stepNumber, skipCompletionCheck = false) {
    if (stepNumber < 1 || stepNumber > this.stepsConfig.length) return;
    
    if (this.sidebarCart && window.innerWidth < 1024) {
      this.sidebarCart.classList.remove('expanded');
      document.body.style.overflow = '';
    }
    
    const colorFilters = this.querySelectorAll('.bundle-color-filter-wrapper');
    colorFilters.forEach(filter => {
      const filterStep = parseInt(filter.getAttribute('data-step'));
      const filterTabContent = filter.getAttribute('data-tab-content');
      
      if (filterStep === stepNumber) {
        if (filterTabContent) {
          const currentStepElement = this.querySelector(`.bundle-step[data-step="${stepNumber}"]`);
          if (currentStepElement) {
            const activeGrid = currentStepElement.querySelector('.bundle-product-grid.active');
            const activeTabContent = activeGrid ? activeGrid.getAttribute('data-tab-content') : null;
            filter.style.display = (activeTabContent === filterTabContent) ? 'block' : 'none';
          } else {
            filter.style.display = 'none';
          }
        } else {
          filter.style.display = 'block';
        }
      } else {
        filter.style.display = 'none';
      }
    });
    
    const allSteps = this.querySelectorAll('[data-step]');
    allSteps.forEach(stepElement => {
      const step = parseInt(stepElement.getAttribute('data-step'));
      if (stepElement) {
        stepElement.style.display = step === stepNumber ? 'block' : 'none';
      }
    });

    const allTabs = this.querySelectorAll('[data-step-tabs]');
    allTabs.forEach(tabsElement => {
      const tabStep = parseInt(tabsElement.getAttribute('data-step-tabs'));
      tabsElement.style.display = tabStep === stepNumber ? 'flex' : 'none';
    });

    const currentStepElement = this.querySelector(`.bundle-step[data-step="${stepNumber}"]`);
    if (currentStepElement) {
      const stepTabs = this.querySelectorAll(`.bundle-tab[data-step="${stepNumber}"]`);
      if (stepTabs.length > 0) {
        stepTabs.forEach(t => t.classList.remove('active'));
        stepTabs[0].classList.add('active');
        
        const stepTabContents = currentStepElement.querySelectorAll('.bundle-product-grid');
        stepTabContents.forEach(content => content.classList.remove('active'));
        if (stepTabContents.length > 0) {
          stepTabContents[0].classList.add('active');
          
          const firstTabContent = stepTabContents[0].getAttribute('data-tab-content');
          const colorFilters = this.querySelectorAll('.bundle-color-filter-wrapper[data-step="' + stepNumber + '"]');
          colorFilters.forEach(filter => {
            const filterTabContent = filter.getAttribute('data-tab-content');
            if (filterTabContent) {
              filter.style.display = (filterTabContent === firstTabContent) ? 'block' : 'none';
            }
          });
        }
      }
    }

    this.currentStep = stepNumber;
    
    if (!skipCompletionCheck) {
      this.checkStepCompletion();
    } else {
      this.updateButtonState();
      this.scrollToActiveCartStep();
    }
    
    this.saveToLocalStorage();

    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    setTimeout(() => {
      this.applyColorFilters();
      this.updateClearButtonVisibility();
    }, 100);
  }

  initColorFilters() {
    const colorSwatches = this.querySelectorAll('.bundle-color-swatch');
    
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        swatch.classList.toggle('active');
        this.applyColorFilters();
        this.updateClearButtonVisibility();
      });
    });
    
    const clearButtons = this.querySelectorAll('.bundle-color-filter-clear');
    clearButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.clearColorFilters(button);
      });
    });
    
    setTimeout(() => {
      this.applyColorFilters();
      this.updateClearButtonVisibility();
    }, 100);
  }

  clearColorFilters(clearButton) {
    const filterWrapper = clearButton.closest('.bundle-color-filter-wrapper');
    if (!filterWrapper) return;
    
    const swatches = filterWrapper.querySelectorAll('.bundle-color-swatch.active');
    swatches.forEach(swatch => {
      swatch.classList.remove('active');
    });
    
    this.applyColorFilters();
    this.updateClearButtonVisibility();
  }

  updateClearButtonVisibility() {
    const clearButtons = this.querySelectorAll('.bundle-color-filter-clear');
    clearButtons.forEach(button => {
      const filterWrapper = button.closest('.bundle-color-filter-wrapper');
      if (!filterWrapper) return;
      
      const hasActiveSwatches = filterWrapper.querySelectorAll('.bundle-color-swatch.active').length > 0;
      button.style.display = hasActiveSwatches ? 'block' : 'none';
    });
  }

  applyColorFilters() {
    const currentStepElement = this.querySelector(`.bundle-step[data-step="${this.currentStep}"]`);
    if (!currentStepElement) return;
    
    const activeGrids = currentStepElement.querySelectorAll('.bundle-product-grid.active');
    
    activeGrids.forEach(grid => {
      const tabContentId = grid.getAttribute('data-tab-content');
      const productId = tabContentId ? tabContentId.replace('product-', '') : null;
      
      let currentStepFilter = null;
      if (productId) {
        currentStepFilter = this.querySelector(`.bundle-color-filter-wrapper[data-product-id="${productId}"][data-step="${this.currentStep}"]`);
      } else {
        currentStepFilter = this.querySelector(`.bundle-color-filter-wrapper[data-step="${this.currentStep}"]:not([data-product-id])`);
      }
      
      if (!currentStepFilter) {
        const cards = grid.querySelectorAll('.bundle-product-card');
        cards.forEach(card => card.style.display = '');
        return;
      }
      
      const activeSwatches = currentStepFilter.querySelectorAll('.bundle-color-swatch.active');
      const selectedColors = Array.from(activeSwatches).map(swatch => 
        swatch.getAttribute('data-color-slug')
      ).filter(c => c);
      
      const productCards = grid.querySelectorAll('.bundle-product-card');
      
      productCards.forEach(card => {
        const cardColors = card.getAttribute('data-colors');
        
        if (selectedColors.length === 0) {
          card.style.display = '';
        } else if (cardColors) {
          const cardColorArray = cardColors.split(' ').filter(c => c);
          const hasMatch = selectedColors.some(selectedColor => 
            cardColorArray.includes(selectedColor)
          );
          
          card.style.display = hasMatch ? '' : 'none';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  initCustomDropdowns() {
    const dropdowns = this.querySelectorAll('.custom-dropdown');
    
    dropdowns.forEach(dropdown => {
      const select = dropdown.previousElementSibling;
      const selectedEl = dropdown.querySelector('.custom-dropdown-selected');
      const optionEls = dropdown.querySelectorAll('.custom-dropdown-option');
      const textEl = dropdown.querySelector('.custom-dropdown-text');
      const productCard = dropdown.closest('.bundle-product-card');
      
      selectedEl.addEventListener('click', (e) => {
        e.stopPropagation();
        
        this.querySelectorAll('.custom-dropdown').forEach(dd => {
          if (dd !== dropdown) {
            dd.classList.remove('open');
          }
        });
        
        dropdown.classList.toggle('open');
      });
      
      optionEls.forEach(optionEl => {
        optionEl.addEventListener('click', () => {

          if (optionEl.classList.contains('is-disabled') || optionEl.dataset.disabled === '1' || optionEl.getAttribute('aria-disabled') === 'true') {
            return;
          }

          const value = optionEl.getAttribute('data-value');
          const text = optionEl.textContent.trim();
          const priceAttr = optionEl.getAttribute('data-price');
          const maxInventoryAttr = optionEl.getAttribute('data-max-inventory');
          
          select.value = value;
          textEl.textContent = text;
          
          optionEls.forEach(opt => opt.classList.remove('selected'));
          optionEl.classList.add('selected');
          
          dropdown.classList.remove('open');
          
          const addButton = productCard.querySelector('.bundle-add-btn');
          const availableAttr = optionEl.dataset.available;

          if (addButton && availableAttr != null) {
            addButton.setAttribute('data-available', availableAttr);
          }

          if (addButton && value) {
            addButton.setAttribute('data-variant-id', value);
            if (maxInventoryAttr) {
              addButton.setAttribute('data-max-inventory', maxInventoryAttr);
            }
            this.updateAddButtonsState();
            this.updateAddButtonsStateWithCart();
          }
          
          if (priceAttr && productCard) {
            const originalPrice = parseInt(priceAttr, 10) || 0;          // cents
            const discountedPrice = this.applyDiscountCents(originalPrice);

            productCard.setAttribute('data-original-price', String(originalPrice));
            productCard.setAttribute('data-discounted-price', String(discountedPrice));

            const priceCurrentEl = productCard.querySelector('.price-current');
            const priceCompareEl = productCard.querySelector('.price-compare');

            if (priceCurrentEl) priceCurrentEl.textContent = this.formatPrice(discountedPrice / 100);
            if (priceCompareEl && this.settings.discountPercentage > 0) {
              priceCompareEl.textContent = this.formatPrice(originalPrice / 100);
            }
          }
        });
      });
      
      if (select) {
        select.addEventListener('change', () => {
          const availableAttr = selectedOption.dataset.available;
          if (addButton && availableAttr != null) {
            addButton.setAttribute('data-available', availableAttr);
          }
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption) {
            const maxInventoryAttr = selectedOption.getAttribute('data-max-inventory');
            const addButton = productCard.querySelector('.bundle-add-btn');
            if (addButton && maxInventoryAttr) {
              addButton.setAttribute('data-max-inventory', maxInventoryAttr);
              addButton.setAttribute('data-variant-id', select.value);
            }
            this.updateAddButtonsState();
            this.updateAddButtonsStateWithCart();
          }
        });
      }
    });
    
    document.addEventListener('click', () => {
      this.querySelectorAll('.custom-dropdown').forEach(dd => {
        dd.classList.remove('open');
      });
    });
  }

  refreshAllDropdownAvailability(cart = this.getCartCached()) {
    let anySelectionChanged = false;

    const cards = Array.from(this.querySelectorAll('.bundle-product-card'));

    for (const card of cards) {
      const select = card.querySelector('.bundle-size-select');
      const dropdown = card.querySelector('.custom-dropdown');
      if (!select || !dropdown) continue;

      const optionDivs = Array.from(dropdown.querySelectorAll('.custom-dropdown-option'));
      const nativeOptions = Array.from(select.options);

      for (const opt of nativeOptions) {
        const variantId = String(opt.value);
        const availableFlag = (opt.dataset.available === 'true');
        const maxInv = parseInt(opt.getAttribute('data-max-inventory') || '', 10);

        const inBundle = this.getVariantQuantityInBundle(variantId);
        const inCart = this.getVariantQtyInCart(cart, variantId);

        const hasLimit = availableFlag && Number.isFinite(maxInv) && maxInv > 0;

        const remaining = hasLimit ? (maxInv - inCart - inBundle) : 999999;
        const selectable = availableFlag && (remaining > 0);

        opt.disabled = !selectable;

        const div = optionDivs.find(d => String(d.getAttribute('data-value')) === variantId);
        if (div) {
          div.classList.toggle('is-disabled', !selectable);
          div.setAttribute('aria-disabled', selectable ? 'false' : 'true');
          div.dataset.disabled = selectable ? '0' : '1';
        }
      }

      const currentOpt = nativeOptions.find(o => o.value === select.value);
      if (currentOpt && currentOpt.disabled) {
        const firstOk = nativeOptions.find(o => !o.disabled);
        if (firstOk) {
          select.value = firstOk.value;
          anySelectionChanged = true;
        }
      }

      this.applySelectionFromSelect(card);
    }

    return anySelectionChanged;
  }

  applySelectionFromSelect(productCard) {
    const select = productCard.querySelector('.bundle-size-select');
    const dropdown = productCard.querySelector('.custom-dropdown');
    if (!select || !dropdown) return;

    const selectedOpt = select.options[select.selectedIndex];
    if (!selectedOpt) return;

    const value = selectedOpt.value;
    const priceAttr = selectedOpt.getAttribute('data-price');
    const maxInvAttr = selectedOpt.getAttribute('data-max-inventory');
    const availableAttr = selectedOpt.dataset.available;

    const textEl = dropdown.querySelector('.custom-dropdown-text');
    const optionDivs = Array.from(dropdown.querySelectorAll('.custom-dropdown-option'));

    optionDivs.forEach(d => d.classList.toggle('selected', d.getAttribute('data-value') === value));

    const matchDiv = optionDivs.find(d => d.getAttribute('data-value') === value);
    if (textEl) {
      const txt = (matchDiv ? matchDiv.textContent : selectedOpt.textContent).trim();
      textEl.textContent = txt;
    }

    const addBtn = productCard.querySelector('.bundle-add-btn');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', value);
      if (maxInvAttr != null) addBtn.setAttribute('data-max-inventory', maxInvAttr);
      if (availableAttr != null) addBtn.setAttribute('data-available', availableAttr);
    }

    if (priceAttr) {
      const original = parseInt(priceAttr, 10) || 0;
      const discounted = this.applyDiscountCents(original);

      productCard.setAttribute('data-original-price', String(original));
      productCard.setAttribute('data-discounted-price', String(discounted));

      const priceCurrentEl = productCard.querySelector('.price-current');
      const priceCompareEl = productCard.querySelector('.price-compare');

      if (priceCurrentEl) priceCurrentEl.textContent = this.formatPrice(discounted / 100);
      if (priceCompareEl && this.settings.discountPercentage > 0) {
        priceCompareEl.textContent = this.formatPrice(original / 100);
      }
    }
  }

  syncDropdownUI(dropdown, select, productCard) {
    const textEl = dropdown.querySelector('.custom-dropdown-text');
    const optionDivs = Array.from(dropdown.querySelectorAll('.custom-dropdown-option'));

    const selectedOpt = Array.from(select.options).find(o => o.value === select.value) || select.options[select.selectedIndex];
    if (!selectedOpt) return;

    const value = selectedOpt.value;
    const priceAttr = selectedOpt.getAttribute('data-price');
    const maxInvAttr = selectedOpt.getAttribute('data-max-inventory');

    const matchDiv = optionDivs.find(d => d.getAttribute('data-value') === value);
    if (textEl) textEl.textContent = (matchDiv ? matchDiv.textContent : selectedOpt.textContent).trim();

    optionDivs.forEach(d => d.classList.toggle('selected', d.getAttribute('data-value') === value));

    const addBtn = productCard.querySelector('.bundle-add-btn');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', value);
      if (maxInvAttr != null) addBtn.setAttribute('data-max-inventory', maxInvAttr);
    }

    if (priceAttr) {
      const original = parseInt(priceAttr, 10) || 0;
      const discounted = this.applyDiscountCents(original);

      productCard.setAttribute('data-original-price', String(original));
      productCard.setAttribute('data-discounted-price', String(discounted));

      const priceCurrentEl = productCard.querySelector('.price-current');
      const priceCompareEl = productCard.querySelector('.price-compare');

      if (priceCurrentEl) priceCurrentEl.textContent = this.formatPrice(discounted / 100);
      if (priceCompareEl && this.settings.discountPercentage > 0) {
        priceCompareEl.textContent = this.formatPrice(original / 100);
      }
    }

    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
  }

  initQuantityControls() {
    const quantityBtns = this.querySelectorAll('.quantity-btn');
    const quantityInputs = this.querySelectorAll('.quantity-input');
    
    this.updateAllQuantityButtons();

    this.querySelectorAll('.quantity-input').forEach((input) => {
      this.updateMobileQtySelect(input);
    });

    quantityBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const action = btn.getAttribute('data-action');
        const quantityInput = btn.closest('.bundle-quantity').querySelector('.quantity-input');
        let currentValue = parseInt(quantityInput.getAttribute('data-value')) || 1;
        const min = 1;
        const max = parseInt(quantityInput.getAttribute('data-max')) || 99;

        if (action === 'plus' && currentValue < max) {
          currentValue++;
        } else if (action === 'minus' && currentValue > min) {
          currentValue--;
        }

        quantityInput.setAttribute('data-value', currentValue);
        quantityInput.value = this.formatQuantity(currentValue);
        this.updateQuantityButtonsState(quantityInput);
        this.updateAddButtonsState();
      });
    });

        quantityInputs.forEach(input => {
      input.setAttribute('min', '1');
      
      input.addEventListener('focus', (e) => {
        const currentValue = parseInt(input.getAttribute('data-value')) || 1;
        input.value = currentValue.toString();
        input.select();
      });

      input.addEventListener('input', (e) => {
        let value = e.target.value.replace(/\D/g, '');
        const max = parseInt(input.getAttribute('data-max')) || 99;
        
        if (value !== '') {
          const numValue = parseInt(value);
          if (numValue > max) {
            value = max.toString();
          }
          input.setAttribute('data-value', value);
          this.updateQuantityButtonsState(input);
          this.updateAddButtonsState();
        }
      });

      input.addEventListener('blur', (e) => {
        const min = 1;
        const max = parseInt(input.getAttribute('data-max')) || 99;
        let value = parseInt(input.getAttribute('data-value')) || min;

        if (isNaN(value) || value < min) {
          value = min;
        } else if (value > max) {
          value = max;
        }

        input.setAttribute('data-value', value);
        input.value = this.formatQuantity(value);
        this.updateQuantityButtonsState(input);
        this.updateAddButtonsState();
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          input.blur();
        }
      });
    });
  }

  initMobileQtyCustomDropdowns() {
    const cards = Array.from(this.querySelectorAll('.bundle-product-card'));

    cards.forEach(card => {
      const qtyWrap = card.querySelector('.bundle-quantity');
      const qtyInput = card.querySelector('.quantity-input');
      if (!qtyWrap || !qtyInput) return;

      let dd = qtyWrap.querySelector('.custom-dropdown.custom-qty-dropdown');
      if (!dd) {
        dd = document.createElement('div');
        dd.className = 'custom-dropdown custom-qty-dropdown';
        dd.innerHTML = `
        <div class="custom-dropdown-selected" data-qty-selected>
          <span class="custom-dropdown-text" data-qty-text>01</span>
          <span class="custom-dropdown-arrow">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
        <div class="custom-dropdown-options" data-qty-options></div>
      `;
        qtyWrap.appendChild(dd);

        const selected = dd.querySelector('[data-qty-selected]');
        selected.addEventListener('click', (e) => {
          e.stopPropagation();

          this.querySelectorAll('.custom-dropdown.open').forEach(x => {
            if (x !== dd) x.classList.remove('open');
          });

          if (dd.classList.contains('is-disabled')) return;
          dd.classList.toggle('open');
        });

        dd.addEventListener('click', (e) => {
          const opt = e.target.closest('.custom-dropdown-option');
          if (!opt) return;

          if (
            opt.classList.contains('is-disabled') ||
            opt.dataset.disabled === '1' ||
            opt.getAttribute('aria-disabled') === 'true'
          ) {
            return;
          }

          const val = parseInt(opt.getAttribute('data-value') || '1', 10) || 1;
          this.setQuantityFromUI(qtyInput, val);
          dd.classList.remove('open');
        });
      }

      this.updateMobileQtyDropdownUI(qtyInput);
    });

    if (!this._mobileQtyOutsideClickBound) {
      this._mobileQtyOutsideClickBound = true;
      document.addEventListener('click', () => {
        this.querySelectorAll('.custom-dropdown.open').forEach(dd => dd.classList.remove('open'));
      });
    }
  }

  getMobileQtyMaxFromInput(qtyInput) {
    const maxAttr = parseInt(
      qtyInput.getAttribute('data-max') || qtyInput.getAttribute('max') || '30',
      10
    );

    if (!Number.isFinite(maxAttr)) return 30;

    const capped = Math.min(30, maxAttr);
    return Math.max(0, capped);
  }

  setQuantityFromUI(qtyInput, qty) {
    const safeQty = Math.max(1, qty);

    qtyInput.setAttribute('data-value', String(safeQty));
    qtyInput.value = this.formatQuantity(safeQty);

    this.updateQuantityButtonsState(qtyInput);
    this.updateAddButtonsState();
  }

  updateMobileQtyDropdownUI(qtyInput) {
    const qtyWrap = qtyInput.closest('.bundle-quantity');
    const dd = qtyWrap?.querySelector('.custom-dropdown.custom-qty-dropdown');
    if (!dd) return;

    const textEl = dd.querySelector('[data-qty-text]');
    const optionsEl = dd.querySelector('[data-qty-options]');
    if (!textEl || !optionsEl) return;

    const max = this.getMobileQtyMaxFromInput(qtyInput);

    if (max <= 0) {
      dd.classList.add('is-disabled');
      dd.classList.remove('open');
      optionsEl.innerHTML = '';
      textEl.textContent = '00';
      return;
    } else {
      dd.classList.remove('is-disabled');
    }

    let current = parseInt(qtyInput.getAttribute('data-value') || '1', 10) || 1;
    if (current > max) current = max;
    if (current < 1) current = 1;

    qtyInput.setAttribute('data-value', String(current));
    qtyInput.value = this.formatQuantity(current);

    textEl.textContent = this.formatQuantity(current);

    optionsEl.innerHTML = '';
    for (let i = 1; i <= max; i++) {
      const div = document.createElement('div');
      div.className = 'custom-dropdown-option' + (i === current ? ' selected' : '');
      div.setAttribute('data-value', String(i));
      div.textContent = this.formatQuantity(i);
      div.setAttribute('aria-disabled', 'false');
      div.dataset.disabled = '0';
      optionsEl.appendChild(div);
    }
  }

  formatQuantity(num) {
    return num < 10 ? `0${num}` : `${num}`;
  }

  resetQtyToOne(productCard) {
    if (!productCard) return;

    const quantityInput = productCard.querySelector('.quantity-input');
    if (!quantityInput) return;

    quantityInput.setAttribute('data-value', '1');
    quantityInput.value = this.formatQuantity(1);

    const mobileSelect = productCard.querySelector('.bundle-qty-select');
    if (mobileSelect) {
      mobileSelect.value = '1';
    }

    this.updateQuantityButtonsState(quantityInput);

    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
  }

  updateQuantityButtonsState(quantityInput) {
    if (!quantityInput) return;
    
    const quantityContainer = quantityInput.closest('.bundle-quantity');
    if (!quantityContainer) return;
    
    const minusBtn = quantityContainer.querySelector('.quantity-minus');
    const plusBtn = quantityContainer.querySelector('.quantity-plus');
    
    const currentValue = parseInt(quantityInput.getAttribute('data-value')) || 1;
    const min = 1;
    const max = parseInt(quantityInput.getAttribute('data-max')) || 99;
    
    const canDecrease = currentValue > min;
    const canIncrease = currentValue < max;
    
    if (minusBtn) {
      const svgPath = minusBtn.querySelector('svg path');
      if (svgPath) {
        svgPath.setAttribute('fill', canDecrease ? '#6A6A6A' : '#D4D4D4');
      }
      minusBtn.disabled = !canDecrease;
      minusBtn.style.pointerEvents = canDecrease ? 'auto' : 'none';
      minusBtn.style.opacity = canDecrease ? '1' : '0.5';
    }
    
    if (plusBtn) {
      const svgPath = plusBtn.querySelector('svg path');
      if (svgPath) {
        svgPath.setAttribute('fill', canIncrease ? '#6A6A6A' : '#D4D4D4');
      }
      plusBtn.disabled = !canIncrease;
      plusBtn.style.pointerEvents = canIncrease ? 'auto' : 'none';
      plusBtn.style.opacity = canIncrease ? '1' : '0.5';
    }

    this.updateMobileQtySelect(quantityInput);

    this.updateMobileQtyDropdownUI(quantityInput);
  }

  ensureMobileQtySelect(quantityInput) {
    const wrap = quantityInput?.closest('.bundle-quantity');
    if (!wrap) return null;

    let sel = wrap.querySelector('.quantity-select');
    if (!sel) return null;

    if (!sel.dataset.bound) {
      sel.dataset.bound = '1';

      sel.addEventListener('change', () => {
        const v = parseInt(sel.value, 10);
        if (!Number.isFinite(v) || v < 1) return;

        quantityInput.setAttribute('data-value', String(v));
        quantityInput.value = this.formatQuantity(v);

        this.updateQuantityButtonsState(quantityInput);
        this.updateAddButtonsState();
        this.updateAddButtonsStateWithCart();
      });
    }

    return sel;
  }

  updateMobileQtySelect(quantityInput) {
    const sel = this.ensureMobileQtySelect(quantityInput);
    if (!sel) return;

    let max = parseInt(quantityInput.getAttribute('data-max') || '0', 10);
    if (!Number.isFinite(max)) max = 0;

    const limit = Math.min(30, Math.max(0, max));

    if (limit <= 0) {
      sel.innerHTML = '';
      sel.disabled = true;
      return;
    }

    sel.disabled = false;

    let current = parseInt(quantityInput.getAttribute('data-value') || '1', 10);
    if (!Number.isFinite(current) || current < 1) current = 1;
    if (current > limit) current = limit;

    const prevLimit = parseInt(sel.dataset.limit || '0', 10);
    if (prevLimit !== limit) {
      sel.innerHTML = '';
      for (let i = 1; i <= limit; i++) {
        const opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = String(i);
        sel.appendChild(opt);
      }
      sel.dataset.limit = String(limit);
    }

    sel.value = String(current);
  }

  updateAllQuantityButtons() {
    const quantityInputs = this.querySelectorAll('.quantity-input');
    quantityInputs.forEach(input => {
      this.updateQuantityButtonsState(input);
    });
  }

  initAddToBundleButtons() {
    const addButtons = this.querySelectorAll('.bundle-add-btn');

    addButtons.forEach(btn => {
      if (!btn.hasAttribute('data-original-html')) {
        btn.setAttribute('data-original-html', btn.innerHTML);
      }

      btn.addEventListener('click', async () => {
        if (btn.disabled) return;
        if (btn.hasAttribute('data-showing-feedback')) return;

        const productCard = btn.closest('.bundle-product-card');
        if (!productCard) return;

        const productId = btn.getAttribute('data-product-id') || '';
        const stepNumber = parseInt(btn.getAttribute('data-step'), 10) || 1;
        const stepId = this.stepsConfig?.[stepNumber - 1]?.stepId;

        if (!stepId) {
          console.error('Step ID not found for step:', stepNumber);
          return;
        }

        const quantityInput = productCard.querySelector('.quantity-input');
        if (!quantityInput) return;

        const quantity = parseInt(quantityInput.getAttribute('data-value'), 10) || 1;

        const sizeSelect = productCard.querySelector('.bundle-size-select');
        const selectedVariantId = sizeSelect ? sizeSelect.value : btn.getAttribute('data-variant-id');
        if (!selectedVariantId) return;

        let inventoryQuantityAttr = btn.getAttribute('data-max-inventory');

        if (sizeSelect && sizeSelect.selectedOptions && sizeSelect.selectedOptions.length > 0) {
          const optMax = sizeSelect.selectedOptions[0].getAttribute('data-max-inventory');
          if (optMax !== null && optMax !== undefined) {
            inventoryQuantityAttr = optMax;
          }
        }

        const inv = await this.fetchVariantInventoryLimit(selectedVariantId, inventoryQuantityAttr);

        const cart = await this.fetchCartFresh();
        const alreadyInCart = this.getVariantQtyInCart(cart, selectedVariantId);
        const alreadyInBundle = this.getVariantQuantityInBundle(String(selectedVariantId));

        const availableQuantity = inv.hasLimit
          ? (inv.maxInventory - alreadyInCart - alreadyInBundle)
          : 999999;

        if (inv.hasLimit && quantity > availableQuantity) {
          this.updateAddButtonsState();
          this.updateAddButtonsStateWithCart();
          return;
        }

        const standardText = this.getLocaleString('bundle_builder.standard') || '';
        const selectedSizeText = sizeSelect
          ? (sizeSelect.options[sizeSelect.selectedIndex]?.text || standardText)
          : standardText;

        const productName = productCard.querySelector('.bundle-product-name')?.textContent.trim() || '';
        const productVariant = productCard.querySelector('.bundle-product-variant')?.textContent.trim() || '';
        const productImage = productCard.querySelector('.bundle-product-image img')?.src || '';

        const originalPrice = parseInt(productCard.getAttribute('data-original-price'), 10) || 0;
        const discountMultiplier = (100 - this.settings.discountPercentage) / 100;
        const discountedPrice = Math.ceil(originalPrice * discountMultiplier - 1e-9);

        const bundleItem = {
          variantId: selectedVariantId,
          productId: productId,
          quantity: quantity,
          size: selectedSizeText,
          name: productName,
          variant: productVariant,
          originalPrice: originalPrice,
          discountedPrice: discountedPrice,
          image: productImage,
          stepId: stepId,
          stepNumber: stepNumber
        };

        this.addToBundleState(bundleItem);
        this.showAddedFeedback(btn);

        const qInput = productCard.querySelector('.quantity-input');
        if (qInput) {
          qInput.setAttribute('data-value', '1');
          qInput.value = this.formatQuantity(1);
          this.updateQuantityButtonsState(qInput);
        }

        this.resetQtyToOne(productCard);

        this.updateAddButtonsState();
        this.updateAddButtonsStateWithCart();
      });
    });

    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
  }
  
  getVariantQuantityInBundle(variantId) {
    let totalQuantity = 0;
    Object.values(this.itemsByStep).forEach(stepItems => {
      stepItems.forEach(item => {
        if (item.variantId === variantId) {
          totalQuantity += item.quantity;
        }
      });
    });
    return totalQuantity;
  }

  applyDiscountCents(originalCents) {
    const pct = Number(this.settings.discountPercentage) || 0;
    const payPct = 100 - pct;

    return Math.floor((originalCents * payPct + 99) / 100);
  }

  syncAllCardPrices() {
    const cards = this.querySelectorAll('.bundle-product-card');

    cards.forEach(card => {
      const original = parseInt(card.getAttribute('data-original-price'), 10);
      if (!Number.isFinite(original)) return;

      const discounted = this.applyDiscountCents(original);

      card.setAttribute('data-discounted-price', String(discounted));

      const priceCurrentEl = card.querySelector('.price-current');
      const priceCompareEl = card.querySelector('.price-compare');

      if (priceCurrentEl) priceCurrentEl.textContent = this.formatPrice(discounted / 100);
      if (priceCompareEl) priceCompareEl.textContent = this.formatPrice(original / 100);
    });
  }
  
  hasInventoryLimit(inventoryQuantity) {
    if (inventoryQuantity === null || inventoryQuantity === undefined || inventoryQuantity === '') {
      return false;
    }
    const quantity = parseInt(inventoryQuantity);
    return !isNaN(quantity) && quantity >= 0;
  }
  
  getEffectiveMaxInventory(inventoryQuantity) {
    if (!this.hasInventoryLimit(inventoryQuantity)) {
      return 999999;
    }
    return parseInt(inventoryQuantity);
  }

  getCartCached() {
    return this._cartCache?.cart || null;
  }

  getVariantIdAndFallbackInvAttrFromCard(productCard) {
    const { selectedVariantId, inventoryQuantityAttr } =
      this.getSelectedVariantContext(productCard);

    return { selectedVariantId, inventoryQuantityAttr };
  }
  
  updateAddButtonsState() {
    const addButtons = this.querySelectorAll('.bundle-add-btn');
    const cartCached = this.getCartCached();
    
    addButtons.forEach(btn => {
      const productCard = btn.closest('.bundle-product-card');
      const sizeSelect = productCard?.querySelector('.bundle-size-select');
      const quantityInput = productCard?.querySelector('.quantity-input');
      const isAvailable = btn.getAttribute('data-available');
      if (isAvailable === 'false') {
        btn.disabled = true;
        btn.classList.add('disabled');
        return;
      }
      
      const selectedVariantId = sizeSelect ? sizeSelect.value : btn.getAttribute('data-variant-id');
      const requestedQuantity = quantityInput ? parseInt(quantityInput.getAttribute('data-value')) || 1 : 1;
      
      let inventoryQuantityAttr = btn.getAttribute('data-max-inventory');
      
      if (sizeSelect && sizeSelect.selectedOptions.length > 0) {
        const selectedOption = sizeSelect.selectedOptions[0];
        const optionMaxInventory = selectedOption.getAttribute('data-max-inventory');
        if (optionMaxInventory !== null && optionMaxInventory !== undefined) {
          inventoryQuantityAttr = optionMaxInventory;
        }
      }
      
      const maxInventory = this.getEffectiveMaxInventory(inventoryQuantityAttr);
      const hasLimit = this.hasInventoryLimit(inventoryQuantityAttr);
      const alreadyAdded = this.getVariantQuantityInBundle(String(selectedVariantId));
      const alreadyInCartCached = this.getVariantQtyInCart(cartCached, selectedVariantId);

      const availableQuantity = hasLimit
        ? (maxInventory - alreadyInCartCached - alreadyAdded)
        : 999999;
      
      if (quantityInput) {
        const currentValue = parseInt(quantityInput.getAttribute('data-value')) || 1;
        const maxFromInput = parseInt(quantityInput.getAttribute('data-max')) || 999999;
        const safeAvailable = hasLimit ? Math.max(0, availableQuantity) : 999999;
        const effectiveMax = hasLimit ? Math.max(1, Math.min(maxFromInput, safeAvailable)) : 999999;
        quantityInput.setAttribute('data-max', effectiveMax.toString());
        
        let adjustedValue = currentValue;
        if (adjustedValue < 1) {
          adjustedValue = 1;
        } else if (hasLimit && adjustedValue > effectiveMax) {
          adjustedValue = effectiveMax;
        }
        
        if (adjustedValue !== currentValue) {
          quantityInput.setAttribute('data-value', adjustedValue.toString());
          quantityInput.value = this.formatQuantity(adjustedValue);
        }
        
        this.updateQuantityButtonsState(quantityInput);
      }
      
      if (hasLimit) {
        if (availableQuantity <= 0 || requestedQuantity > availableQuantity) {
          btn.disabled = true;
          btn.classList.add('disabled');
        } else {
          btn.disabled = false;
          btn.classList.remove('disabled');
        }
      } else {
        btn.disabled = false;
        btn.classList.remove('disabled');
      }
    });
    this.updateQuickAdd13ButtonsState();
  }

  async updateAddButtonsStateWithCart() {
    const addButtons = this.querySelectorAll('.bundle-add-btn');
    const cart = await this.fetchCartFresh();

    addButtons.forEach(btn => {
      const productCard = btn.closest('.bundle-product-card');
      if (!productCard) return;

      const sizeSelect = productCard.querySelector('.bundle-size-select');
      const quantityInput = productCard.querySelector('.quantity-input');

      const selectedVariantId = sizeSelect
        ? sizeSelect.value
        : btn.getAttribute('data-variant-id');

      if (!selectedVariantId) return;

      let inventoryQuantityAttr = btn.getAttribute('data-max-inventory');

      if (sizeSelect && sizeSelect.selectedOptions.length > 0) {
        const optMax = sizeSelect.selectedOptions[0].getAttribute('data-max-inventory');
        if (optMax !== null && optMax !== undefined) {
          inventoryQuantityAttr = optMax;
        }
      }

      const requestedQty =
        quantityInput ? parseInt(quantityInput.getAttribute('data-value')) || 1 : 1;

      const hasLimit = this.hasInventoryLimit(inventoryQuantityAttr);
      const maxInventory = this.getEffectiveMaxInventory(inventoryQuantityAttr);

      const alreadyInBundle = this.getVariantQuantityInBundle(String(selectedVariantId));
      const alreadyInCart = this.getVariantQtyInCart(cart, selectedVariantId);

      const available = hasLimit
        ? (maxInventory - alreadyInCart - alreadyInBundle)
        : 999999;

      if (available <= 0 || requestedQty > available) {
        btn.disabled = true;
        btn.classList.add('disabled');
      } else {
        btn.disabled = false;
        btn.classList.remove('disabled');
      }

      if (quantityInput && hasLimit) {
        const effectiveMax = Math.max(1, available);
        quantityInput.setAttribute('data-max', effectiveMax.toString());

        let currentValue = parseInt(quantityInput.getAttribute('data-value')) || 1;
        if (currentValue > effectiveMax) {
          quantityInput.setAttribute('data-value', effectiveMax.toString());
          quantityInput.value = this.formatQuantity(effectiveMax);
        }

        this.updateQuantityButtonsState(quantityInput);
      }
    });

    this.updateQuickAdd13ButtonsState();

    const changed = this.refreshAllDropdownAvailability(cart);
    if (changed) {
      this.updateAddButtonsState();
    }
  }

  addToBundleState(item) {
    const stepItems = this.itemsByStep[item.stepId];
    if (!stepItems) {
      console.error('Step not found:', item.stepId);
      return;
    }
    
    const existingIndex = stepItems.findIndex(
      bundleItem => bundleItem.variantId === item.variantId
    );

    if (existingIndex !== -1) {
      stepItems[existingIndex].quantity += item.quantity;
    } else {
      stepItems.push(item);
    }

    this.updateSidebarCart();
    this.updateProgress();
    this.checkStepCompletion();
    this.refreshAllDropdownAvailability(this.getCartCached());
    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
    this.saveToLocalStorage();
    
    this.dispatchEvent(new CustomEvent('bundle-updated', {
      detail: {
        itemsByStep: this.itemsByStep,
        totalItems: this.getTotalItemsCount()
      },
      bubbles: true
    }));
  }

  removeFromBundle(variantId, stepId) {
    const stepItems = this.itemsByStep[stepId];
    if (stepItems) {
      this.itemsByStep[stepId] = stepItems.filter(item => item.variantId !== variantId);
    }

    this.updateSidebarCart();
    this.updateProgress();
    this.checkStepCompletion();
    this.refreshAllDropdownAvailability(this.getCartCached());
    this.updateAddButtonsState();
    this.updateAddButtonsStateWithCart();
    this.saveToLocalStorage();
  }

  getStepItemsCount(stepId) {
    const stepItems = this.itemsByStep[stepId] || [];
    return stepItems.reduce((total, item) => total + item.quantity, 0);
  }

  getTotalItemsCount() {
    return Object.values(this.itemsByStep).reduce((total, stepItems) => {
      return total + stepItems.reduce((stepTotal, item) => stepTotal + item.quantity, 0);
    }, 0);
  }

  getAllItems() {
    return Object.values(this.itemsByStep).flat();
  }

  clearBundle() {
    Object.keys(this.itemsByStep).forEach(stepId => {
      this.itemsByStep[stepId] = [];
    });
    this.updateSidebarCart();
    this.updateProgress();
    this.saveToLocalStorage();
    this.dispatchEvent(new CustomEvent('bundle-cleared', { bubbles: true }));
  }

  saveToLocalStorage() {
    try {
      const bundleData = {
        itemsByStep: this.itemsByStep,
        currentStep: this.currentStep,
        timestamp: Date.now()
      };
      localStorage.setItem('wedgeguys_bundle_builder', JSON.stringify(bundleData));
    } catch (error) {
      console.error('Failed to save bundle to localStorage:', error);
    }
  }

  loadFromLocalStorage() {
    try {
      const savedData = localStorage.getItem('wedgeguys_bundle_builder');
      if (savedData) {
        const bundleData = JSON.parse(savedData);
        
        const dayInMs = 24 * 60 * 60 * 1000;
        if (Date.now() - bundleData.timestamp < dayInMs) {
          this.itemsByStep = bundleData.itemsByStep || {};
          this.currentStep = bundleData.currentStep || 1;
          
          this.stepsConfig.forEach(step => {
            if (!this.itemsByStep[step.stepId]) {
              this.itemsByStep[step.stepId] = [];
            }
          });
          
          setTimeout(() => {
            this.initCartStepStates();
            this.updateSidebarCart();
            this.updateProgress();
            this.checkStepCompletion();
            this.updateAddButtonsState();
            this.updateAddButtonsStateWithCart();
            this.updateAllQuantityButtons();
            this.checkScrollIndicators();
            

            this.goToStep(this.currentStep, true);
          }, 100);
        } else {
          localStorage.removeItem('wedgeguys_bundle_builder');
        }
      }
    } catch (error) {
      console.error('Failed to load bundle from localStorage:', error);
    }
  }

  clearLocalStorage() {
    try {
      localStorage.removeItem('wedgeguys_bundle_builder');
    } catch (error) {
      console.error('Failed to clear localStorage:', error);
    }
  }

  initSidebarCart() {
    if (this.ctaButton) {
      this.ctaButton.addEventListener('click', () => {
        this.handleCTAClick();
      });
    }

    const cta = this.querySelector('.bundle-cart-cta-button');
    if (cta && this.sidebarCart) {
      cta.addEventListener('click', () => {
        this.sidebarCart.classList.remove('expanded');
        document.body.style.overflow = '';
      });
    }

    this.initCartStepStates();
    this.updateSidebarCart();
    this.updateProgress();
    
    setTimeout(() => {
      this.checkScrollIndicators();
    }, 100);
  }

  initCartStepStates() {
    this.stepsConfig.forEach((step, index) => {
      const cartStepElement = this.cartStepElements[step.stepId];
      if (cartStepElement) {
        if (index === 0) {
          cartStepElement.classList.add('active');
        } else {
          cartStepElement.classList.add('inactive');
          cartStepElement.style.display = 'flex';
        }
      }
    });
  }

  updateSidebarCart() {
    this.stepsConfig.forEach(step => {
      const container = this.querySelector(`[data-items-container="step-${step.stepNumber}"]`);
      if (!container) return;
      
      const existingItems = container.querySelectorAll('[data-variant-id]');
      existingItems.forEach(item => item.remove());
      
      const placeholders = container.querySelectorAll('[data-placeholder]');
      const stepItems = this.itemsByStep[step.stepId] || [];
      
      stepItems.forEach((item) => {
        const itemElement = this.renderCartItem(item);
        
        if (placeholders[0]) {
          container.insertBefore(itemElement, placeholders[0]);
        } else {
          container.appendChild(itemElement);
        }
      });
      
      placeholders.forEach((placeholder, index) => {
        if (index < (3 - stepItems.length)) {
          placeholder.style.display = 'flex';
        } else {
          placeholder.style.display = 'none';
        }
      });
    });

    this.updateTotals();
    
    setTimeout(() => {
      this.checkScrollIndicators();
    }, 0);
  }

  renderCartItem(item) {
    const div = document.createElement('div');
    div.className = 'bundle-cart-item';
    div.setAttribute('data-variant-id', item.variantId);

    const quantityBadge = `x${item.quantity}`;
    const sizeFirstLetter = item.size ? item.size.charAt(0).toUpperCase() : '';
    div.innerHTML = `
      <div class="bundle-cart-item-image">
        ${item.image ? `<img src="${item.image}" alt="${item.name}">` : ''}
        <div class="bundle-cart-item-badges">
          ${item.quantity > 1 ? `<div class="bundle-cart-item-badge">${quantityBadge}</div>` : ''}
          ${sizeFirstLetter !== '' ? `<div class="bundle-cart-item-badge">${sizeFirstLetter}</div>` : ''}
        </div>
      </div>
      <button class="bundle-cart-item-remove" type="button" aria-label="${this.getLocaleString('bundle_builder.remove_item') || 'Remove item'}">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.878125 11.0896L0 10.2115L4.66667 5.54479L0 0.878125L0.878125 0L5.54479 4.66667L10.2115 0L11.0896 0.878125L6.42292 5.54479L11.0896 10.2115L10.2115 11.0896L5.54479 6.42292L0.878125 11.0896Z" fill="#6A6A6A"/>
        </svg>
      </button>
    `;

    const removeBtn = div.querySelector('.bundle-cart-item-remove');
    removeBtn.addEventListener('click', () => {
      this.removeFromBundle(item.variantId, item.stepId);
    });

    return div;
  }

  updateProgress() {
    let totalRequired = 0;
    let totalAdded = 0;
    
    this.stepsConfig.forEach(step => {
      const stepItemsCount = this.getStepItemsCount(step.stepId);
      const countedItems = Math.min(stepItemsCount, step.minProducts);
      totalRequired += step.minProducts;
      totalAdded += countedItems;
    });
    
    const progress = totalRequired > 0 ? Math.min((totalAdded / totalRequired) * 100, 100) : 0;

    if (this.progressBar) {
      this.progressBar.style.width = `${progress}%`;
    }
  }

  updateTotals() {
    let originalTotal = 0;
    let discountedTotal = 0;
    
    Object.values(this.itemsByStep).forEach(stepItems => {
      stepItems.forEach(item => {
        originalTotal += item.originalPrice * item.quantity;
        discountedTotal += item.discountedPrice * item.quantity;
      });
    });

    if (this.totalOriginal) {
      this.totalOriginal.textContent = this.formatPrice(originalTotal / 100);
    }

    if (this.totalDiscounted) {
      this.totalDiscounted.textContent = this.formatPrice(discountedTotal / 100);
    }
  }

  formatPrice(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  updateButtonState() {
    if (!this.ctaButton) return;
    
    const currentStepConfig = this.stepsConfig[this.currentStep - 1];
    if (!currentStepConfig) return;
    
    const itemsCount = this.getStepItemsCount(currentStepConfig.stepId);
    const isCompleted = itemsCount >= currentStepConfig.minProducts;
    const isLastStep = this.currentStep === this.stepsConfig.length;
    
    let allCompleted = true;
    this.stepsConfig.forEach(step => {
      const stepItemsCount = this.getStepItemsCount(step.stepId);
      if (stepItemsCount < step.minProducts) {
        allCompleted = false;
      }
    });
    
    const wasDisabled = this.ctaButton.disabled;
    
    if (allCompleted) {
      this.ctaButton.disabled = false;
      this.ctaButton.textContent = this.ctaButton.getAttribute('data-add-to-cart-text') || this.getLocaleString('bundle_builder.add_to_bundle') || 'ADD TO CART';
    } else if (isCompleted && !isLastStep) {
      this.ctaButton.disabled = false;
      this.ctaButton.textContent = this.ctaButton.getAttribute('data-next-step-text') || 'NEXT STEP';
    } else if (isLastStep && isCompleted) {
      this.ctaButton.disabled = false;
      this.ctaButton.textContent = this.ctaButton.getAttribute('data-add-to-cart-text') || this.getLocaleString('bundle_builder.add_to_bundle') || 'ADD TO CART';
    } else {
      this.ctaButton.disabled = true;
      this.ctaButton.textContent = isLastStep 
        ? (this.ctaButton.getAttribute('data-add-to-cart-text') || this.getLocaleString('bundle_builder.add_to_bundle') || 'ADD TO CART')
        : (this.ctaButton.getAttribute('data-next-step-text') || 'NEXT STEP');
    }
    
    if (wasDisabled && !this.ctaButton.disabled && isCompleted) {
      this.scrollToCtaButtonIfNeeded();
    }
  }
  
  scrollToCtaButtonIfNeeded() {
    if (window.innerWidth < 1024) return;
    
    if (!this.ctaButton) return;
    
    requestAnimationFrame(() => {
      setTimeout(() => {
        const buttonRect = this.ctaButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        
        const isButtonVisible = (
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0 &&
          buttonRect.left < viewportWidth &&
          buttonRect.right > 0
        );
        
        if (!isButtonVisible) {
          this.smoothScrollToButton();
        }
      }, 150);
    });
  }
  
  smoothScrollToButton() {
    const buttonRect = this.ctaButton.getBoundingClientRect();
    const currentScrollY = window.scrollY || window.pageYOffset;
    const viewportHeight = window.innerHeight;
    
    const targetScrollY = currentScrollY + buttonRect.top - (viewportHeight / 2) + (buttonRect.height / 2);
    
    const startScrollY = currentScrollY;
    const distance = targetScrollY - startScrollY;
    const duration = 800;
    const startTime = performance.now();
    
    const easeInOutCubic = (t) => {
      return t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
    
    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutCubic(progress);
      
      window.scrollTo(0, startScrollY + distance * easedProgress);
      
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };
    
    requestAnimationFrame(animateScroll);
  }

  getLocaleString(key) {
    const dataKey = 'data-locale-' + key.replace(/\./g, '-').replace(/_/g, '-');
    const value = this.getAttribute(dataKey);
    return value || null;
  }

  checkStepCompletion() {
    let allCompleted = true;
    let currentStepCompleted = false;
    
    this.stepsConfig.forEach((step, index) => {
      const stepNumber = index + 1;
      const itemsCount = this.getStepItemsCount(step.stepId);
      const isCompleted = itemsCount >= step.minProducts;
      const cartStepElement = this.cartStepElements[step.stepId];
      
      if (!cartStepElement) return;
      
      cartStepElement.style.display = 'flex';
      
      if (isCompleted) {
        cartStepElement.classList.add('completed');
        cartStepElement.classList.remove('active', 'inactive');
      } else {
        cartStepElement.classList.remove('completed');
        allCompleted = false;
        
        let canBeActive = true;
        for (let i = 0; i < index; i++) {
          const prevStep = this.stepsConfig[i];
          const prevItemsCount = this.getStepItemsCount(prevStep.stepId);
          if (prevItemsCount < prevStep.minProducts) {
            canBeActive = false;
            break;
          }
        }
        
        if (canBeActive) {
          cartStepElement.classList.add('active');
          cartStepElement.classList.remove('inactive');
        } else {
          cartStepElement.classList.add('inactive');
          cartStepElement.classList.remove('active');
        }
      }
      
      if (stepNumber === this.currentStep && isCompleted) {
        currentStepCompleted = true;
      }
    });
    
    if (this.cartSubtitle && this.goalText) {
      if (allCompleted) {
        this.cartSubtitle.style.display = 'none';
        this.goalText.style.display = 'block';
      } else {
        this.cartSubtitle.style.display = 'block';
        this.goalText.style.display = 'none';
      }
    }
    
    this.updateButtonState();
    this.scrollToActiveCartStep();
    
    for (let i = 0; i < this.stepsConfig.length; i++) {
      const step = this.stepsConfig[i];
      const itemsCount = this.getStepItemsCount(step.stepId);
      if (itemsCount < step.minProducts) {
        const targetStep = i + 1;
        if (targetStep < this.currentStep) {
          this.goToStep(targetStep, true);
        }
        break;
      }
    }
  }

  scrollToActiveCartStep() {
    if (window.innerWidth < 1024) return;
    
    const sidebarInner = this.querySelector('.bundle-sidebar-cart-inner');
    if (!sidebarInner) return;
    
    const activeStep = sidebarInner.querySelector('.bundle-cart-step.active');
    if (!activeStep) return;
    
    const footer = sidebarInner.querySelector('.bundle-cart-footer');
    const footerHeight = footer ? footer.offsetHeight : 0;
    
    const sidebarRect = sidebarInner.getBoundingClientRect();
    const stepRect = activeStep.getBoundingClientRect();
    
    const isStepVisible = 
      stepRect.top >= sidebarRect.top && 
      stepRect.bottom <= (sidebarRect.bottom - footerHeight);
    
    if (!isStepVisible) {
      const scrollTop = activeStep.offsetTop - sidebarInner.offsetTop - 20;
      
      sidebarInner.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  }


  handleCTAClick() {
    let allCompleted = true;
    this.stepsConfig.forEach(step => {
      const itemsCount = this.getStepItemsCount(step.stepId);
      if (itemsCount < step.minProducts) {
        allCompleted = false;
      }
    });

    if (allCompleted) {
      this.addBundleToCart();
    } else {
      const nextStep = this.currentStep + 1;
      if (nextStep <= this.stepsConfig.length) {
        this.goToStep(nextStep);
      }
    }
  }

  async addBundleToCart() {
    const allItems = this.getAllItems();
    
    if (allItems.length === 0) {
      alert(this.getLocaleString('bundle_builder.please_add_items') || 'Please add items to your bundle');
      return;
    }

    const formData = {
      items: allItems.map(item => ({
        id: item.variantId,
        quantity: item.quantity
      }))
    };

    try {
      if (this.ctaButton) {
        this.ctaButton.disabled = true;
        this.ctaButton.textContent = this.getLocaleString('bundle_builder.adding') || 'ADDING...';
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // this.clearBundle();
      // this.clearLocalStorage();

      if (this.settings.discountCode) {
        window.location.href = `/discount/${encodeURIComponent(this.settings.discountCode)}?redirect=${encodeURIComponent('/cart')}`;
      } else {
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(this.getLocaleString('bundle_builder.failed_to_add') || 'Failed to add items to cart. Please try again.');
      
      if (this.ctaButton) {
        this.ctaButton.disabled = false;
        this.ctaButton.textContent = this.ctaButton.getAttribute('data-add-to-cart-text') || this.getLocaleString('bundle_builder.add_to_bundle') || 'ADD TO CART';
      }
    }
  }

  initMobileSidebar() {
    if (!this.sidebarCart) return;

    const header = this.sidebarCart.querySelector('.bundle-cart-header');
    
    const toggleDrawer = () => {
      if (window.innerWidth < 1024) {
        const isExpanding = !this.sidebarCart.classList.contains('expanded');
        this.sidebarCart.classList.toggle('expanded');
        
        if (isExpanding) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    };

    const closeDrawer = () => {
      if (window.innerWidth < 1024) {
        this.sidebarCart.classList.remove('expanded');
        document.body.style.overflow = '';
      }
    };

    if (header) {
      header.addEventListener('click', toggleDrawer);
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
        this.sidebarCart.classList.remove('expanded');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('click', (e) => {
      if (window.innerWidth < 1024 && this.sidebarCart.classList.contains('expanded')) {
        if (!this.sidebarCart.contains(e.target)) {
          closeDrawer();
        }
      }
    });

    const inner = this.sidebarCart.querySelector('.bundle-sidebar-cart-inner');
    if (inner) {
      inner.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  initCtaCloseSidebar() {
    const cta = this.querySelector('.bundle-cart-cta-button');
    if (!cta) return;

    cta.addEventListener('click', () => {
      if (!this.sidebarCart) return;
      this.sidebarCart.classList.remove('expanded');
      document.body.style.overflow = '';
    });
  }

  checkScrollIndicators() {
    const cartSteps = this.querySelectorAll('.bundle-cart-step');
    
    cartSteps.forEach(step => {
      const itemsContainer = step.querySelector('.bundle-cart-items');
      if (!itemsContainer) return;
      
      const hasScroll = itemsContainer.scrollHeight > itemsContainer.clientHeight;
      
      if (hasScroll) {
        step.classList.add('has-scroll');
        
        itemsContainer.addEventListener('scroll', () => {
          const isScrolledToBottom = 
            itemsContainer.scrollHeight - itemsContainer.scrollTop <= itemsContainer.clientHeight + 5;
          
          if (isScrolledToBottom) {
            step.classList.remove('has-scroll');
          } else {
            step.classList.add('has-scroll');
          }
        });
      } else {
        step.classList.remove('has-scroll');
      }
    });
  }

  showAddedFeedback(button) {
    const existingTimeout = button.getAttribute('data-feedback-timeout');
    if (existingTimeout) {
      clearTimeout(parseInt(existingTimeout));
    }
    
    const originalHTML = button.getAttribute('data-original-html') || button.innerHTML;
    if (!button.hasAttribute('data-original-html')) {
      button.setAttribute('data-original-html', originalHTML);
    }
    
    button.setAttribute('data-showing-feedback', 'true');
    
    button.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.8084 6.3975L20.5584 4.18875C20.2773 3.90852 19.8965 3.75116 19.4995 3.75116C19.1026 3.75116 18.7218 3.90852 18.4406 4.18875L9.75095 12.7716L6.31126 9.43406C6.02952 9.15474 5.64859 8.9984 5.25185 8.99928C4.85512 9.00016 4.47488 9.15818 4.19438 9.43875L1.94438 11.6887C1.66358 11.97 1.50586 12.3512 1.50586 12.7486C1.50586 13.146 1.66358 13.5272 1.94438 13.8084L8.65876 20.5584C8.79805 20.6978 8.96343 20.8083 9.14544 20.8837C9.32745 20.9591 9.52253 20.9979 9.71954 20.9979C9.91655 20.9979 10.1116 20.9591 10.2936 20.8837C10.4757 20.8083 10.641 20.6978 10.7803 20.5584L22.8131 8.52281C22.9527 8.38314 23.0633 8.21729 23.1387 8.03476C23.214 7.85224 23.2526 7.65664 23.2521 7.45918C23.2517 7.26172 23.2123 7.06629 23.1361 6.8841C23.06 6.70191 22.9486 6.53655 22.8084 6.3975ZM9.71532 19.5L3.00095 12.75L5.25095 10.5C5.25368 10.5023 5.25619 10.5048 5.25845 10.5075L9.22876 14.3597C9.36891 14.4968 9.5572 14.5736 9.75329 14.5736C9.94938 14.5736 10.1377 14.4968 10.2778 14.3597L19.5066 5.25L21.7509 7.4625L9.71532 19.5Z" fill="white"/>
      </svg>
    `;
    button.style.background = '#15A61A';
    button.style.color = '#fff';
    button.style.borderColor = '#15A61A';

    const timeoutId = setTimeout(() => {
      button.innerHTML = originalHTML;
      button.style.background = '';
      button.style.color = '';
      button.style.borderColor = '';
      button.removeAttribute('data-showing-feedback');
      button.removeAttribute('data-feedback-timeout');

      if (button.classList.contains('bundle-product-btn-13')) {
        this.updateQuickAdd13ButtonsState();
      }
    }, 2000);
    
    button.setAttribute('data-feedback-timeout', timeoutId.toString());
  }
  async fetchCartFresh(ttlMs = 2000) {
    const now = Date.now();
    if (this._cartCache.cart && (now - this._cartCache.ts) < ttlMs) {
      return this._cartCache.cart;
    }

    try {
      const res = await fetch(`/cart.js?t=${now}`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart fetch failed');
      const cart = await res.json();
      this._cartCache = { ts: now, cart };
      return cart;
    } catch (e) {
      return null;
    }
  }

  getVariantQtyInCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    const idNum = Number(variantId);
    let qty = 0;
    cart.items.forEach(it => {
      if (Number(it.variant_id) === idNum) qty += (it.quantity || 0);
    });
    return qty;
  }

  async fetchVariantInventoryLimit(variantId, fallbackInventoryAttr, ttlMs = 10000) {
    const now = Date.now();
    const cached = this._variantInventoryCache.get(String(variantId));
    if (cached && (now - cached.ts) < ttlMs) return cached;

    const fallbackHasLimit = this.hasInventoryLimit(fallbackInventoryAttr);
    const fallbackMax = this.getEffectiveMaxInventory(fallbackInventoryAttr);

    try {
      const res = await fetch(`/variants/${variantId}.json?t=${now}`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('variant fetch failed');

      const json = await res.json();
      const v = json && (json.variant || json);

      const inventoryPolicy = v?.inventory_policy;
      const inventoryManagement = v?.inventory_management;
      const invQty = v?.inventory_quantity;

      const fetchedHasLimit =
        inventoryManagement != null &&
        inventoryPolicy !== 'continue' &&
        typeof invQty === 'number' &&
        invQty >= 0;

      const fetchedMax = fetchedHasLimit ? invQty : 999999;

      const hasLimit = fallbackHasLimit || fetchedHasLimit;

      let maxInventory = 999999;
      if (fallbackHasLimit && fetchedHasLimit) {
        maxInventory = Math.min(fallbackMax, fetchedMax);
      } else if (fallbackHasLimit) {
        maxInventory = fallbackMax;
      } else if (fetchedHasLimit) {
        maxInventory = fetchedMax;
      }

      const result = { ts: now, hasLimit, maxInventory };
      this._variantInventoryCache.set(String(variantId), result);
      return result;
    } catch (e) {
      const result = { ts: now, hasLimit: fallbackHasLimit, maxInventory: fallbackMax };
      this._variantInventoryCache.set(String(variantId), result);
      return result;
    }
  }

  getSelectedVariantContext(productCard) {
    const sizeSelect = productCard?.querySelector('.bundle-size-select');
    const addBtn = productCard?.querySelector('.bundle-add-btn');

    const selectedVariantId = sizeSelect ? sizeSelect.value : (addBtn?.getAttribute('data-variant-id') || productCard?.getAttribute('data-variant-id'));
    let inventoryQuantityAttr = addBtn?.getAttribute('data-max-inventory') || productCard?.getAttribute('data-max-inventory');

    if (sizeSelect && sizeSelect.selectedOptions && sizeSelect.selectedOptions.length > 0) {
      const optMax = sizeSelect.selectedOptions[0].getAttribute('data-max-inventory');
      if (optMax !== null && optMax !== undefined) inventoryQuantityAttr = optMax;
    }

    const standardText = this.getLocaleString('bundle_builder.standard') || '';
    const selectedSizeText = sizeSelect
      ? (sizeSelect.options[sizeSelect.selectedIndex]?.text || standardText)
      : standardText;

    return { selectedVariantId, inventoryQuantityAttr, selectedSizeText };
  }

  buildBundleItemFromCard(productCard, variantId, quantity, stepId, stepNumber, productId) {
    const productName = productCard.querySelector('.bundle-product-name')?.textContent.trim() || '';
    const productVariant = productCard.querySelector('.bundle-product-variant')?.textContent.trim() || '';
    const productImage = productCard.querySelector('.bundle-product-image img')?.src || '';

    const originalPrice = parseFloat(productCard.getAttribute('data-original-price')) || 0;
    const discountedPrice = parseFloat(productCard.getAttribute('data-discounted-price')) || originalPrice;

    const { selectedSizeText } = this.getSelectedVariantContext(productCard);

    return {
      variantId: String(variantId),
      productId: String(productId || ''),
      quantity,
      size: selectedSizeText,
      name: productName,
      variant: productVariant,
      originalPrice,
      discountedPrice,
      image: productImage,
      stepId,
      stepNumber
    };
  }

  setQuickAdd13UI(btn, nextQty) {
    const countEl = btn.querySelector('.quick-add-count');
    const labelEl = btn.querySelector('.quick-add-label');
    const suffixEl = btn.querySelector('.quick-add-suffix');
    if (!countEl || !labelEl) return;

    if (nextQty > 0) {
      btn.disabled = false;
      btn.classList.remove('disabled');
      labelEl.textContent = 'Quick Add';
      countEl.textContent = String(nextQty);
      if (suffixEl) suffixEl.style.display = '';
    } else {
      btn.disabled = true;
      btn.classList.add('disabled');
      labelEl.textContent = 'Out of stock';
      countEl.textContent = '';
      if (suffixEl) suffixEl.style.display = 'none';
    }
  }

  async updateQuickAdd13ButtonsState() {
    const token = ++this._quickAddUpdateToken;

    const quickButtons = Array.from(this.querySelectorAll('.bundle-product-btn-13'));
    if (!quickButtons.length) return;

    const cartCached = this.getCartCached();

    const contexts = [];

    for (const btn of quickButtons) {
      const productCard = btn.closest('.bundle-product-card');
      if (!productCard) continue;

      const countEl = btn.querySelector('.quick-add-count');
      const labelEl = btn.querySelector('.quick-add-label');
      const suffixEl = btn.querySelector('.quick-add-suffix');
      if (!countEl || !labelEl) continue;

      const isAvailable = btn.getAttribute('data-available');
      if (isAvailable === 'false') {
        btn.disabled = true;
        btn.classList.add('disabled');
        labelEl.textContent = 'Out of stock';
        countEl.textContent = '';
        if (suffixEl) suffixEl.style.display = 'none';
        continue;
      }

      const { selectedVariantId, inventoryQuantityAttr } =
        this.getVariantIdAndFallbackInvAttrFromCard(productCard);

      if (!selectedVariantId) continue;

      const hasLimitFallback = this.hasInventoryLimit(inventoryQuantityAttr);
      const maxFallback = this.getEffectiveMaxInventory(inventoryQuantityAttr);

      const alreadyInBundle = this.getVariantQuantityInBundle(String(selectedVariantId));
      const alreadyInCartCached = this.getVariantQtyInCart(cartCached, selectedVariantId);

      const availableFallback = hasLimitFallback
        ? (maxFallback - alreadyInCartCached - alreadyInBundle)
        : 999999;

      const nextQtyFallback = Math.max(0, Math.min(13, availableFallback));
      this.setQuickAdd13UI(btn, nextQtyFallback);

      contexts.push({
        btn,
        productCard,
        selectedVariantId,
        inventoryQuantityAttr
      });
    }

    if (token !== this._quickAddUpdateToken) return;

    const cart = await this.fetchCartFresh();
    if (token !== this._quickAddUpdateToken) return;

    const uniq = new Map();
    contexts.forEach(c => {
      if (!uniq.has(String(c.selectedVariantId))) {
        uniq.set(String(c.selectedVariantId), c.inventoryQuantityAttr);
      }
    });

    const ids = Array.from(uniq.keys());
    const BATCH = 8;
    for (let i = 0; i < ids.length; i += BATCH) {
      const chunk = ids.slice(i, i + BATCH);
      await Promise.all(
        chunk.map(id => this.fetchVariantInventoryLimit(id, uniq.get(id)))
      );
      if (token !== this._quickAddUpdateToken) return;
    }

    for (const c of contexts) {
      const { btn, productCard, selectedVariantId, inventoryQuantityAttr } = c;

      const isAvailable = btn.getAttribute('data-available');
      if (isAvailable === 'false') continue;

      const inv = await this.fetchVariantInventoryLimit(selectedVariantId, inventoryQuantityAttr);
      if (token !== this._quickAddUpdateToken) return;

      const alreadyInBundle = this.getVariantQuantityInBundle(String(selectedVariantId));
      const alreadyInCart = this.getVariantQtyInCart(cart, selectedVariantId);

      const available = inv.hasLimit
        ? (inv.maxInventory - alreadyInCart - alreadyInBundle)
        : 999999;

      const nextQty = Math.max(0, Math.min(13, available));
      this.setQuickAdd13UI(btn, nextQty);
    }
  }

  initQuickAdd13Buttons() {
    const quickButtons = this.querySelectorAll('.bundle-product-btn-13');

    quickButtons.forEach(btn => {
      if (!btn.hasAttribute('data-original-html')) {
        btn.setAttribute('data-original-html', btn.innerHTML);
      }

      btn.addEventListener('click', async () => {
        if (btn.disabled) return;
        if (btn.hasAttribute('data-showing-feedback')) return;

        const isAvailable = btn.getAttribute('data-available');
        if (isAvailable === 'false') return;

        const productCard = btn.closest('.bundle-product-card');
        if (!productCard) return;

        const stepNumber = parseInt(productCard.getAttribute('data-step')) || 1;
        const stepId = this.stepsConfig[stepNumber - 1]?.stepId;
        const productId = productCard.getAttribute('data-product-id') || '';

        if (!stepId) return;

        const { selectedVariantId, inventoryQuantityAttr } = this.getSelectedVariantContext(productCard);
        if (!selectedVariantId) return;

        const inv = await this.fetchVariantInventoryLimit(selectedVariantId, inventoryQuantityAttr);

        const cart = await this.fetchCartFresh();
        const alreadyInCart = this.getVariantQtyInCart(cart, selectedVariantId);

        const alreadyInBundle = this.getVariantQuantityInBundle(String(selectedVariantId));

        const available = inv.hasLimit
          ? (inv.maxInventory - alreadyInCart - alreadyInBundle)
          : 999999;

        const qtyToAdd = Math.max(0, Math.min(13, available));

        const newAvailable = available - qtyToAdd;
        const nextQtyUI = Math.max(0, Math.min(13, newAvailable));
        this.setQuickAdd13UI(btn, nextQtyUI);

        if (qtyToAdd <= 0) {
          this.updateAddButtonsState();
          this.updateAddButtonsStateWithCart();
          return;
        }

        const item = this.buildBundleItemFromCard(
          productCard,
          selectedVariantId,
          qtyToAdd,
          stepId,
          stepNumber,
          productId
        );

        this.addToBundleState(item);
        this.showAddedFeedback(btn);

        this.updateAddButtonsState();
        this.updateAddButtonsStateWithCart();

        const changed = this.refreshAllDropdownAvailability(cart);
        if (changed) {
          this.updateAddButtonsState();
        }
      });
    });

    this.updateQuickAdd13ButtonsState();
  }
}

customElements.define('bundle-builder', BundleBuilder);